import { State, SeatingMap, Utils } from "../../seatingMapWrapper";
import config from "../../config";
import SeatingMapService from "../../services/SeatingMapService";
import { GET_ORDER_SUCCESS, SAVE_ORDER_DATA_SUCCESS } from "./orderActions";
import { nextPage } from "./routingActions";
export const GET_SEATING_MAP_REQUEST = "GET_SEATING_MAP_REQUEST";
export const GET_SEATING_MAP_SUCCESS = "GET_SEATING_MAP_SUCCESS";
export const GET_SEATING_MAP_ERROR = "GET_SEATING_MAP_ERROR";

export const GET_SEATING_MAPS_REQUEST = "GET_SEATING_MAPS_REQUEST";
export const GET_SEATING_MAPS_SUCCESS = "GET_SEATING_MAPS_SUCCESS";
export const GET_SEATING_MAPS_ERROR = "GET_SEATING_MAPS_ERROR";

export const SAVE_TICKET_MAPPING_REQUEST = "SAVE_TICKET_MAPPING_REQUEST";
export const SAVE_TICKET_MAPPING_SUCCESS = "SAVE_TICKET_MAPPING_SUCCESS";
export const SAVE_TICKET_MAPPING_ERROR = "SAVE_TICKET_MAPPING_ERROR";
export const SAVE_TICKET_MAPPING_CONFLICT = "SAVE_TICKET_MAPPING_CONFLICT";

export const SEATING_MAP_REQUIRED = "SEATING_MAP_REQUIRED";
export const RESET_SEATING_MAP_EVAL = "RESET_SEATING_MAP_EVAL";

const { ReservationState, ReservationManager } = State.Reservation;
const { Config } = Utils;

export const saveTicketMapping = token => {
  return async (dispatch, getState) => {
    const state = getState();
    const { order, event, seatingMap } = state;
    const seatingMapId = seatingMap.seatingMaps[0]._id;
    const eventId = event.data._id;
    const eventDateId = order.data.eventDateId;
    dispatch({ type: SAVE_TICKET_MAPPING_REQUEST });
    try {
      const result = await SeatingMapService.saveTicketMapping(
        ReservationState.ticketMappingData,
        seatingMapId,
        eventId,
        eventDateId,
        token
      );
      if (result.conflict) {
        dispatch({
          type: SAVE_TICKET_MAPPING_CONFLICT,
          conflicts: result.conflicts
        });
        ReservationManager.onConflict(result.conflicts);
      } else {
        dispatch({ type: SAVE_TICKET_MAPPING_SUCCESS });
        dispatch({ type: GET_ORDER_SUCCESS, order: result.order });
        if (!token) {
          dispatch(nextPage());
        } else {
          dispatch({ type: SAVE_ORDER_DATA_SUCCESS, order: result.order });
        }
      }
    } catch (err) {
      dispatch({ type: SAVE_TICKET_MAPPING_ERROR, error: err });
    }
  };
};

export const getSeatingMap = (eventId, seatingMapId) => {
  return dispatch => {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    SeatingMapService.get(eventId, seatingMapId)
      .then(seatingMap => {
        dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap });
      })
      .catch(err => {
        dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
      });
  };
};

export const getSeatingMapPublic = (eventId, token, orderId) => {
  return dispatch => {
    dispatch({ type: GET_SEATING_MAP_REQUEST });
    SeatingMapService.getPublic(eventId, token, orderId)
      .then(seatingMap => {
        dispatch({ type: GET_SEATING_MAP_SUCCESS, seatingMap });
      })
      .catch(err => {
        dispatch({ type: GET_SEATING_MAP_ERROR, error: err });
      });
  };
};

export const getAllSeatingMaps = (
  eventId,
  eventDateId,
  isReservation = true
) => {
  return (dispatch, getState) => {
    const state = getState();
    const orderId = state.order.data._id;
    dispatch({ type: GET_SEATING_MAPS_REQUEST });
    SeatingMapService.getAll(eventId, eventDateId, orderId)
      .then(async seatingMaps => {
        if (isReservation) {
          await load(seatingMaps[0], state);
        }
        dispatch({ type: GET_SEATING_MAPS_SUCCESS, seatingMaps });
      })
      .catch(err => {
        console.log("error", err);
        dispatch({ type: GET_SEATING_MAPS_ERROR, error: err });
      });
  };
};

const filterTickets = (tickets, seatingMap) => {
  return tickets.filter(ticket => {
    const containsPackagedTicket =
      seatingMap.ticketTypeSet.filter(
        ticketType => String(ticketType) === String(ticket.packageId)
      ).length > 0;
    if (ticket.packageId && containsPackagedTicket) {
      return containsPackagedTicket;
    }
    if (ticket.packageId) {
      delete ticket.packageId;
    }
    return (
      seatingMap.ticketTypeSet.filter(
        ticketType => String(ticketType) === String(ticket.ticketTypeId)
      ).length > 0
    );
  });
};

const load = async (seatingMapData, state) => {
  const eventSeatingMapData = state.event.data.seatingMaps.find(seatingMap => {
    return String(seatingMap.id) === String(seatingMapData._id);
  });
  const tickets = filterTickets(state.order.data.tickets, eventSeatingMapData)
    .reduce((ticketGroups, currentTicket, i) => {
      const { packageId, packageGroupId, packageName } = currentTicket;
      if (packageId) {
        const ticketGroup = ticketGroups.find(
          ticketGroup => packageGroupId === ticketGroup.ticketId
        );
        if (ticketGroup) {
          ticketGroup.ticketIds.push(currentTicket._id);
        } else {
          const newTicketGroup = {
            quantity: 1,
            index: i,
            ticketTypeId: packageId,
            ticketId: packageGroupId,
            ticketTypeName: packageName,
            ticketIds: [currentTicket._id]
          };
          ticketGroups.push(newTicketGroup);
        }
      } else {
        const newTicket = {};
        newTicket.quantity = 1;
        newTicket.index = i;
        newTicket.attendeeName = `${currentTicket.firstName} ${currentTicket.lastName}`;
        newTicket.ticketId = currentTicket._id;
        newTicket.ticketTypeId = currentTicket.ticketTypeId;
        newTicket.ticketTypeName = currentTicket.ticketTypeName;
        const seatingLoc = currentTicket.seatingLocation;
        const seatId =
          seatingLoc && seatingLoc.seat.id !== "unassigned"
            ? seatingLoc.seat.id
            : undefined;
        const tableId =
          seatingLoc && seatingLoc.table.id !== "unassigned"
            ? seatingLoc.seat.id
            : undefined;
        const sectionId =
          seatingLoc && seatingLoc.section.id !== "unassigned"
            ? seatingLoc.section.id
            : undefined;
        newTicket.assignData = {
          seatId,
          tableId,
          sectionId,
          name: seatingLoc && seatingLoc.name
        };
        ticketGroups.push(newTicket);
      }
      return ticketGroups;
    }, [])
    .sort((a, b) => {
      const idA = a.ticketTypeId.toLowerCase();
      const idB = b.ticketTypeId.toLowerCase();
      if (idA > idB) {
        return 1;
      } else if (idA < idB) {
        return -1;
      }
      return 0;
    })
    .map((ticket, i) => {
      ticket.index = i;
      return ticket;
    });
  Config.reservationSearch = eventSeatingMapData.attendeeSearch;
  await SeatingMap.createTicketingSeatingMap(
    seatingMapData.seatingMapData,
    {},
    config("API_URL"),
    {}
  );
  ReservationState.ticketList = tickets;
};

export const resetSeatingMapEvaluation = () => {
  return dispatch => {
    dispatch({ type: RESET_SEATING_MAP_EVAL });
  };
};

export const setSeatingMapRequired = required => {
  return dispatch => {
    dispatch({ type: SEATING_MAP_REQUIRED, required });
  };
};
